import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../images/logo.png'
import { Link, MenuList, Modal, Typography } from '@mui/material';
import Contact from '../Contact/Contact';
import useScrollTrigger from '@mui/material/useScrollTrigger';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: '#d2d2d3fc',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};


const TopBanner = () => {
    const [open, setOpen] = React.useState(false);
    const [mobileMenuBg, setMobileMenuBg] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


    const handleMobileMenuClose = () => {
        setMobileMenuBg(false);
        setMobileMoreAnchorEl(null);
    };


    const handleMobileMenuOpen = (event) => {
        setMobileMenuBg(true);
        setMobileMoreAnchorEl(event.currentTarget);
    };


    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
            sx={{ marginTop: '25px', }}
        >
            {/* <MenuItem>
                <Link sx={{ color: 'gray' }} href="#home" underline="none" data-to-scrollspy-id="home">Home</Link>
            </MenuItem> */}
            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#intro" underline="none" data-to-scrollspy-id="intro">Intro</Link>
            </MenuItem>
            {/* <MenuItem>
                <Link sx={{ color: 'gray' }} href="#about-me" underline="none" data-to-scrollspy-id="about-me">About</Link>
            </MenuItem> */}
            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#skills" underline="none" data-to-scrollspy-id="skills">Skills</Link>
            </MenuItem>

            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#projects" underline="none" data-to-scrollspy-id="projects">Projects</Link>
            </MenuItem>
            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#qualifications" underline="none" data-to-scrollspy-id="qualifications">Qualifications</Link>
            </MenuItem>
            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#blogs" underline="none" data-to-scrollspy-id="blogs">Blogs</Link>
            </MenuItem>

            <MenuItem>
                <Link sx={{ color: 'gray', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} onClick={handleOpen} underline="none">Contact</Link>
            </MenuItem>
        </Menu>
    );

    const trigger = useScrollTrigger();


    return (
        <Box sx={{ flexGrow: 1, }}>
            <AppBar in={trigger} elevation={trigger ? 24 : 0} id='navBar' position="fixed" sx={{ backgroundColor: trigger ? '#2D3436' : '#212529E2', height: '45px', border: 'none', boxShadow: 'none', }}>
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ mr: 2, mt: { xs: '0px', md: '-10px' } }}
                    >
                        <Link sx={{ textDecoration: 'none' }} href='/'>
                            {/* <img style={{ height: '35px', }} src={logo} alt="Likhon" /> */}
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.689)', fontWeight: '400', fontSize: '20px', fontFamily: 'monospace', fontStyle: 'italic', }} variant="p" component="div">
                                Likhon
                            </Typography>
                        </Link>
                    </IconButton>


                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { xs: 'none', md: 'flex', } }}>
                        <MenuList sx={{ display: 'flex', alignItems: 'center', marginTop: '-8px', }}>
                            {/* <MenuItem>
                                <Link sx={{ color: '#cfcbcb', letterSpacing: '1.7px' }} href="#home" underline="none" data-to-scrollspy-id="home">Home</Link>
                            </MenuItem> */}
                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#intro" underline="none" data-to-scrollspy-id="intro">Intro</Link>
                            </MenuItem>
                            {/* <MenuItem>
                                <Link sx={{ color: '#cfcbcb', letterSpacing: '1.7px' }} href="#about-me" underline="none" data-to-scrollspy-id="about-me">About</Link>
                            </MenuItem> */}
                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#skills" underline="none" data-to-scrollspy-id="skills">Skills</Link>
                            </MenuItem>

                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#projects" underline="none" data-to-scrollspy-id="projects">Projects</Link>
                            </MenuItem>
                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#qualifications" underline="none" data-to-scrollspy-id="qualifications">Qualifications</Link>
                            </MenuItem>
                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} href="#blogs" underline="none" data-to-scrollspy-id="blogs">Blogs</Link>
                            </MenuItem>

                            <MenuItem>
                                <Link sx={{ color: '#cfcbcb', fontFamily: 'monospace', fontStyle: 'italic', fontWeight: '600', fontSize: '17px', }} onClick={handleOpen} underline="none">Contact</Link>
                            </MenuItem>
                        </MenuList>
                    </Box>


                    <Box sx={{ display: { xs: 'flex', md: 'none', marginTop: '-5px', } }}>
                        <IconButton
                            size="large"
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {/* {renderMenu} */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Contact></Contact>
                </Box>
            </Modal>
        </Box>
    );
};

export default TopBanner;